import PropTypes from 'prop-types';
import { useEffect } from 'react';
// components
import AuthGuard from 'src/guards/AuthGuard';
import GuestGuard from 'src/guards/GuestGuard';
import useAuth from 'src/hooks/useAuth';
import { setCouponData } from 'src/redux/reducers/appRedirect.reducer';
import { dispatch, useSelector } from 'src/redux/store';
import { applyCouponCode } from 'src/services/apply-coupon';
import LogoOnlyLayout from './LogoOnlyLayout';
import { get } from "lodash";

import MainDashboard from './MainDashboard';

// ----------------------------------------------------------------------

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['dashboard', 'main', 'logoOnly', 'dark']),
};

export default function Layout({ variant = 'dashboard', children }) {
   const { user } = useAuth();
   const {couponData} = useSelector(state=>state.appRedirect);

const applyCoupon=async(couponCode,entityId)=>{
    try{
        await applyCouponCode(couponCode,entityId);
    }catch(error){
        console.error("Error",error);
    }
 };


   useEffect(()=>{

    if(user?.entity?.entity?._id && couponData?.couponCode){
      const couponCode=couponData?.couponCode ?? "";
      const entityId=user?.entity?.entity?._id ?? "";

      applyCoupon(couponCode,entityId);
      dispatch(setCouponData({}));
    }
   },[user?.entity?.entity?._id]);

  if(variant === 'GuestUser'){
    return <GuestGuard>
      <MainDashboard>{children}</MainDashboard>
    </GuestGuard>
  }

  if (variant === 'logoOnly') {
    return <LogoOnlyLayout> {children} </LogoOnlyLayout>;
  }

  return (
    <AuthGuard>
      <MainDashboard>{children}</MainDashboard>
    </AuthGuard>
  );
}
